import { gql } from "@apollo/client"

export const UpdateStore = gql`
mutation UpdateStore($updateStoreId: ID!, $content: contentStore!) {
  updateStore(id: $updateStoreId, content: $content) {
    status
  }
}
`